module.exports = __webpack_public_path__ + "img/1.d18cde94.jpg";